import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { Partner } from 'src/app/models/Partner';
import { PartnerState } from 'src/app/partners/partners.state';

@Component({
    selector: 'app-link-partner-autocomplete',
    templateUrl: './link-partner-autocomplete.component.html',
    styleUrls: ['./link-partner-autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LinkPartnerAutocompleteComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    /* 
    This is the reuseable component to link a Partner to another entity in a form. 

    To make this work you need to pass the form(group) in which this component will be used.
    Make sure the formcontrolName in the form is set to 'partner' !
    
    If you need to preselect a partner you pass it (obj) to the initialValue variable.
 */

    @Select(PartnerState.getPartners) partners$: Observable<Partner[]>;

    @Input() form: UntypedFormGroup;
    @Input() initialValue: any = '';

    partners: Partner[];
    partnerKeyword = 'title';

    constructor() {}

    ngOnInit(): void {
        this.subscriptions.add(this.partners$.subscribe((partners) => (this.partners = partners)));
    }

    openAddPartnerModal() {
        console.log('TODO');
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
